import { RowDownloadVehicleColletionDto } from "@/dtos";
import { DownloadVehicleCollection } from "@/entities";
import { getDownloadVehicleCollectionTypeOption, getPaymentMethodTypeOption } from "@/helpers/options";
import { getCurrentDateTime, getMinutesDifference, parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowDownloadVehicleCollectionDto = (list: DownloadVehicleCollection[]): RowDownloadVehicleColletionDto[] => {
    return list.map(x => {
        const row: RowDownloadVehicleColletionDto = {
            ...x,
            vehicle: x.details?.vehicle ?? 'S/N',
            payment_method_type: getPaymentMethodTypeOption(x.payment_method.type).label,
            connection_type_label: getDownloadVehicleCollectionTypeOption(x.connection_type).label,
            date_creation: parseToLocalDateTimeFromUtc(x.date_transaction?.toString()),
            minutes_difference: getMinutesDifference(x.date_transaction?.toString(), getCurrentDateTime())
        }

        return row;
    });
}